export default {"src":"/_next/static/media/salonIcon.5c0beea4.svg","height":100,"width":100};